import React from 'react'
import { useTranslation } from 'next-i18next'
import { HeroIcons } from '../../lib/utils/heroIcons'
import routes from '../../config/routes'
import Link from 'next/link'
import Image from '../Image'
import useLocale from '../../hooks/useLocale'
import { Language } from '../../types/Language'

export default function NoDashboardContent() {
  const { t } = useTranslation('dashboard')
  const { locale } = useLocale()

  const langPrefix = locale === Language.en ? '' : '/' + locale

  const links = [
    {
      name: t('noContentDashboard.links.faq.title'),
      href: `${process.env.NEXT_PUBLIC_WWW_BASEURL}${langPrefix}/faq/`,
      description: t('noContentDashboard.links.faq.subtitle'),
      icon: HeroIcons.BookmarkSquareIcon,
    },
    {
      name: t('noContentDashboard.links.contact.title'),
      href: `${process.env.NEXT_PUBLIC_WWW_BASEURL}${langPrefix}/contact-us/`,
      description: t('noContentDashboard.links.contact.subtitle'),
      icon: HeroIcons.ChatBubbleBottomCenterIcon,
    },
  ]

  return (
    <main className="mx-auto sm:pt-16">
      <div className="mx-auto text-center">
        <h1 className="mt-4 text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
          {t('noContentDashboard.title')}
        </h1>
        <p className="sm:text-md mt-4 text-base leading-7 text-gray-600 sm:mt-4 sm:leading-8">
          {t('noContentDashboard.subtitle')}
          <Link
            className="ml-1 text-primary hover:cursor-pointer"
            href={routes.properties}
          >
            {t('noContentDashboard.cta')}
          </Link>
        </p>
      </div>

      <Image
        dir="/img/illustrations/"
        fileName="homeoffice-3d-min"
        className="mx-auto mt-10"
        alt="Empty desk illustration - Image by studio4rt on Freepik"
        lazyLoading={false}
      />

      <div className="mx-auto mt-10 flow-root max-w-2xl">
        <div className="pb-8 text-center text-sm text-neutralBlack/80">
          {t('noContentDashboard.help')}
        </div>
        <ul
          role="list"
          className="-mt-6 divide-y divide-gray-900/5 border-b border-gray-900/5"
        >
          {links.map((link, linkIdx) => (
            <li key={linkIdx} className="relative flex gap-x-6 py-6">
              <div className="flex h-10 w-10 flex-none items-center justify-center rounded-lg shadow-sm ring-1 ring-gray-900/10">
                <link.icon
                  className="h-6 w-6 text-primary"
                  aria-hidden="true"
                />
              </div>
              <div className="flex-auto">
                <h3 className="text-sm font-semibold leading-6 text-neutralBlack">
                  <Link href={link.href}>
                    <span className="absolute inset-0" aria-hidden="true" />
                    {link.name}
                  </Link>
                </h3>
                <p className="mt-2 text-sm leading-6 text-neutralBlack/90">
                  {link.description}
                </p>
              </div>
              <div className="flex-none self-center">
                <HeroIcons.ChevronRightIcon
                  className="h-5 w-5 text-neutralBlack/80"
                  aria-hidden="true"
                />
              </div>
            </li>
          ))}
        </ul>
        <div className="mt-10 flex justify-center">
          <Link
            className="flex items-center text-sm font-semibold leading-6 text-primary"
            href={routes.index}
          >
            <HeroIcons.ArrowLeftIcon className="mr-1 h-5 w-auto" />
            {t('noContentDashboard.backToMainMenu')}
          </Link>
        </div>
      </div>
    </main>
  )
}
